import React from "react";
import styled from "styled-components";

import { Announcement } from '../../../AnnouncementInfo';
import { ResourceStrings } from '../../../ResourceStrings';
import { App } from '../../../app';
import { Icon } from "@fluentui/react/lib/Icon";

export interface AnnouncementDetailsProps {
    announcement: Announcement;
}

export default function AnnouncementDetails(props: AnnouncementDetailsProps): JSX.Element {
    function getLocalDate(): string {
        return App.ParseDateTimeToLocal(props.announcement.announcementDate.toString());
    }
    // @TODO: point "tag search" links to DevCom2, currently they all point to DevCom1
    return <Container>
        <div className="announcement">
            <span className="title-container">
                <span className="title" aria-label={props.announcement.title}>{props.announcement.title}</span>
                <span className="subtitle" aria-label={props.announcement.subtitle}>{props.announcement.subtitle}</span>
            </span>
        </div>
        <div className="date" aria-label={getLocalDate()}>{getLocalDate()}</div>
        <div className="completed-feedback">
            {props.announcement.fixedInTopics.map((topic, idx) => <div key={idx}>
                <a
                    className="a emphasize"
                    aria-label={ResourceStrings.resolvedProblemsCount(topic.issueCount, topic.shortName)}
                    href={topic.url}
                    target="_blank"
                    rel="noopener noreferrer">
                    {ResourceStrings.resolvedProblemsCount(topic.issueCount, topic.shortName)}
                    <Icon className="small-icon" iconName="ChevronRight" />
                </a>
            </div>)}
        </div>
        <div>Visual Studio <a href="https://docs.microsoft.com/en-us/visualstudio/productinfo/vs-roadmap?utm_source=devcom" target="_blank" rel="noopener noreferrer">roadmap</a> and <a href={props.announcement.moreInfoUrl} target="_blank" rel="noopener noreferrer">release notes</a></div>
    </Container>;
}

const Container = styled.div`
    .completed-feedback {
        margin-bottom: 0.6rem;
    }
    .completed-feedback i {
        font-size: 0.63em;
        font-weight: bold;
    }
    .title-container {
        vertical-align: bottom;
    }

    .title {
        font-size: 1.8rem;
        font-weight: 500;
        color: #000000;
        display: inline-block;
    }

    .subtitle {
        color: #555555;
        padding-left: 0.7rem;
        display: inline-block;
    }

    .date {
        font-weight: 500;
        margin: 1.6rem 0 1rem 0;
    }

    .summary-text {
        width: 66%;
        margin-bottom: 1rem;
        color: #333333;
        padding: 1rem 0 0.8rem 0;
    }

    .title2 {
        font-size: 2.5rem;
        line-height: 2.9rem;
        margin-bottom: 1.1rem;
        color: #555555;
    }

    .cell {
        display: inline-block;
        vertical-align: top;
    }

    cell.up {
        position: relative;
        top: -0.8rem;
    }

    button.download {
        display: block;
        font-size: 2.2rem;
        color: white;
        background: #1E73BE;
        padding: 0.7rem 3.2rem 0.8rem 3.2rem;
        line-height: 2.6rem;
        margin: 2.8rem 20rem 1rem 0;
        text-decoration: none;
    }

    button.download:hover {
        background: #1f78c7;
        text-decoration: none;
    }

    button.emphasize {
        font-weight: 500;
    }
`